import React from "react"

import cn from "classnames"

import as from "../../styles/auth-styles.module.scss"

const PasswordVisibilityIcon = ({visible, stateToggler}) => {

    return (
        <span
            className={cn(as["input-group-text"], "material-icons-outlined")}
            onClick={stateToggler}
        >
            {visible ? "visibility" : "visibility_off"}
        </span>

    )
}

export default PasswordVisibilityIcon